import { useEffect, Dispatch, useState, SetStateAction } from 'react';
import {
  getUserRoles,
  getUserRolesAdmin,
  IDeaNumUser,
  IError,
  IUser,
  ResponseCSOSHeaders,
  useUserContext,
} from '../common';
import { left, right, fold, map as emap } from 'fp-ts/lib/Either';
import { pathOr } from 'rambda';
import { compose as lcompose } from 'lodash/fp';

export const useUserRoleSearch = ({
  forRegistrantsNCoordinators,
  email,
  deaNumber,
  serialNumber,
}: {
  forRegistrantsNCoordinators: boolean;
  email: string | null;
  deaNumber: string | null;
  serialNumber: string | null;
}) => {
  const { user } = useUserContext();

  const [userRoles, setUserRoles] = useState<IDeaNumUser[]>([]);

  useEffect(() => {
    lcompose(
      emap(handleRequest(setUserRoles)),
      startRequest
    )({ forRegistrantsNCoordinators, user, email, deaNumber, serialNumber });
  }, [forRegistrantsNCoordinators, user, email, deaNumber, serialNumber]);

  return {
    userRoles,
  };
};

const handleRequest =
  (dispatch: Dispatch<SetStateAction<IDeaNumUser[]>>) =>
  ({
    hR,
    forRegistrantsNCoordinators,
    email,
    deaNumber,
    serialNumber,
  }: {
    hR: ResponseCSOSHeaders;
    forRegistrantsNCoordinators: boolean;
    email: string | null;
    deaNumber: string | null;
    serialNumber: string | null;
    firstName: string | null;
    lastName: string | null;
  }) => {
    forRegistrantsNCoordinators
      ? getUserRoles(hR)({
          email,
          deaNumber,
          serialNumber,
          firstName: null,
          lastName: null,
        }).then(
          fold<IError, IDeaNumUser[], void>(
            console.error, // TODO
            dispatch
          )
        )
      : getUserRolesAdmin(hR)({
          email,
          deaNumber,
          serialNumber,
        }).then(
          fold<IError, IDeaNumUser[], void>(
            console.error, // TODO
            dispatch
          )
        );
  };

const startRequest = lcompose(
  ({
    forRegistrantsNCoordinators,
    user,
    email,
    deaNumber,
    serialNumber,
  }: {
    forRegistrantsNCoordinators: boolean;
    user: IUser;
    email: string | null;
    deaNumber: string | null;
    serialNumber: string | null;
  }) =>
    pathOr(void 0, 'icam.headers')(user) !== void 0 &&
    (email !== null ||
      (deaNumber !== null && deaNumber.length === 9) ||
      serialNumber !== null)
      ? right({
          forRegistrantsNCoordinators,
          deaNumber,
          email,
          serialNumber,

          hR: pathOr(void 0, 'icam.headers')(user),
        })
      : left(void 0)
);
